import { useAppSelector } from 'redux/hooks';

export default function useFeatureFlagChecker(flagKey: string) {
  const featureFlags = useAppSelector(s => s.auth.featureFlags);
  return featureFlags.includes(flagKey);
}
